<label>
  <ng-container *ngIf="label && reverse">
    <span [class.disabled]="disabled">{{ label | transloco }}</span>
  </ng-container>
  <nz-switch
    [(ngModel)]="internalValue"
    [nzDisabled]="disabled"
    (blur)="syncExternalTouched()"
    (ngModelChange)="onModelChange($event)">
  </nz-switch>
  <ng-container *ngIf="label && !reverse">
    <span [class.disabled]="disabled">{{ label | transloco }}</span>
  </ng-container>
</label>
<ui-icon
  nz-tooltip
  *ngIf="icon"
  [key]="icon"
  [nzTooltipTitle]="tooltip">
</ui-icon>
